import getInfoItinerary from './getInfoItinerary';
import getInfoLandTour from './getInfoLandTour';
import getResumeItinerary from './getResumeItinerary';
import getInfoPrice from './getInfoPrice';
import getBookingLinkPromoParams from './getBookingLinkPromoParams';
import getProductViewLink from './getProductViewLink';
import getQuickBookingLink from './getQuickBookingLink';


export { getInfoItinerary, getInfoLandTour, getResumeItinerary, getInfoPrice, getBookingLinkPromoParams, getProductViewLink, getQuickBookingLink };
